<!-- src/components/SourceItem.vue -->
<template>
  <div
    class="flex items-start gap-2 p-2.5 bg-gray-50/50 rounded-lg border border-gray-100 hover:bg-gray-50 transition-colors"
  >
    <div class="text-xs text-gray-500 font-medium min-w-[20px]">
      {{ index + 1 }}.
    </div>
    <div class="flex-1">
      <div class="text-xs font-medium text-gray-700 flex items-center gap-2">
        <span>{{ source.source }}</span>
        <!-- Namespace label pro Gemini -->
        <span
          v-if="source.namespaceLabel"
          class="px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px]"
        >
          {{ source.namespaceLabel }}
        </span>
      </div>
      <div class="text-xs text-gray-500 mt-1 flex items-center gap-3 flex-wrap">
        <span v-if="source.score && source.score !== null">
          📊 Relevance:
          <span class="font-medium">{{ Math.round(source.score * 100) }}%</span>
        </span>
        <span v-if="source.type" class="flex items-center gap-1">
          <span>📁</span>
          {{ source.type }}
        </span>
        <!-- Link na soubor (pro Gemini) -->
        <a
          v-if="source.uri"
          :href="source.uri"
          target="_blank"
          class="text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1"
        >
          🔗 Otevřít zdroj
        </a>
      </div>
      <!-- Výňatek ze zdroje, pokud existuje -->
      <div
        v-if="source.text"
        class="mt-2 text-xs text-gray-600 italic line-clamp-2"
      >
        "{{ truncateText(source.text, 150) }}"
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  source: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// Helper funkce pro zkrácení textu
function truncateText(text, maxLength) {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + "...";
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
